import { useCallback, useEffect, useRef, useState } from 'react';

export interface CopyToastState {
  message: string | null;
  copy: (text: string, message?: string) => void;
}

export function useCopyToast(): CopyToastState {
  const [message, setMessage] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    };
  }, []);

  const show = useCallback((text: string) => {
    setMessage(text);
    if (timerRef.current !== null) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setMessage(null), 1600);
  }, []);

  const copy = useCallback(
    (text: string, successMessage = 'Скопировано') => {
      const failure = () => show('Не удалось скопировать, выделите и нажмите Ctrl+C');
      if (!navigator.clipboard) {
        failure();
        return;
      }
      void navigator.clipboard.writeText(text).then(() => show(successMessage), failure);
    },
    [show],
  );

  return { message, copy };
}
